import type { Maybe } from '@adornis/base/utilTypes.js';

export const FREE_FORM_MAIL_MAX_RECIPIENTS = 500;
export const FREE_FORM_MAIL_PLACEHOLDERS = ['fullName', 'firstName', 'lastName', 'email'] as const;

export const personalizeFreeFormText = (
  text: string,
  recipient: { firstName?: Maybe<string>; lastName?: Maybe<string>; email?: Maybe<string> },
  escape: (value: string) => string,
): string => {
  const values = {
    fullName: `${recipient.firstName ?? ''} ${recipient.lastName ?? ''}`.trim(),
    firstName: recipient.firstName ?? '',
    lastName: recipient.lastName ?? '',
    email: recipient.email ?? '',
  };
  return text.replace(/\{\{(fullName|firstName|lastName|email)\}\}/g, (_match, key: keyof typeof values) =>
    escape(values[key]),
  );
};
